import axios from 'axios';

export default {
    name: 'forgot-password',
    // Initial data.
    data() {
        return {
            username: '',
            buttonClasses: ['is-fullwidth'],
            // This will eventually get replaced with a generic token
            token: process.env.VUE_APP_QV4_API_HASH,
            loadingState: false
        };
    },
    mounted() {
        let data = {
            hash: this.token,
            name: 'WEB'
        };

        axios
            .post(`${process.env.VUE_APP_QV4_API}/environments/login`, data)
            .then(response => {
                this.token = response.data.token;
            })
            .catch(() => {});

        this.$emit('authCode', null);
    },
    computed: {
        // If username input is filled out
        isCompleted() {
            return this.username;
        }
    },
    // Methods needed for this component.
    methods: {
        // Submit form event.
        onSubmit() {
            // Add the loading spinner icon to the button.
            this.loadingState = true;

            // Get user information from the API.
            axios
                .get(
                    `${
                        process.env.VUE_APP_QV4_API
                    }/users/verification-code?username=${this.username}`,
                    {
                        headers: {
                            'x-api-key': this.token
                        }
                    }
                )
                .then(() => {
                    this.$emit('userInfo', {username: this.username});
                    this.$emit('currentView', 'enter-code');
                    this.$emit(
                        'currentTransition',
                        'component-slide-fade-left'
                    );
                    this.$emit('currentAlert', null);
                })
                // If the API request fails due to connectivity or any other reason.
                .catch(() => {
                    // Remove loading spinner on button
                    this.loadingState = false;

                    // If user data doesn't exist, display an alert for bad username.
                    // Set alert data.
                    let alert = {
                            message: this.$t('HC_OOPS_SOMETHING_WENT_WRONG'),
                            status: 'danger',
                            icon: 'exclamation-circle-outline'
                        },
                        index = this.buttonClasses.indexOf('button-loading');

                    // Remove loading spinner icon from button.
                    if (index > -1) {
                        this.buttonClasses.splice(index, 1);
                    }

                    // Send alert data to parent component.
                    this.$emit('currentAlert', alert);
                    this.loadingState = false;
                });
        },
        // Transition to LoginForm component on Back to Login click.
        onClickBackToLogin(e) {
            e.preventDefault();
            this.$emit('currentView', 'login-form');
            this.$emit('currentTransition', 'component-slide-fade-down');
            this.$emit('currentAlert', null);
        },
        // Transition to Support component on Forgot Quore ID click.
        onClickForgotQuoreID(e) {
            e.preventDefault();
            this.$emit('currentView', 'support');
            this.$emit('currentStatus', 'quoreid');
            this.$emit('currentTransition', 'component-slide-fade-up');
            this.$emit('currentAlert', null);
        }
    }
};
